import config from 'config';
import { getPropertyFromRoutes } from 'utils/routeUtils';
import { HORSE_RACE_UPDATE_RECEIVED } from '../actions/raceUpdate';
import { timeStampToUnix } from '../../../utils/LocalDateTimeHelper';
export const LOAD = 'horse-racing/fast-results/LOAD';
export const LOAD_SUCCESS = 'horse-racing/fast-results/LOAD_SUCCESS';
export const LOAD_FAIL = 'horse-racing/fast-results/LOAD_FAIL';

const initialState = {
  loaded: false
};

const FR_RACE_LIMIT = 10;

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        fastResults: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case HORSE_RACE_UPDATE_RECEIVED:
      if (state.fastResults) {
        return {
          ...state,
          fastResults: applyRaceUpdate(action.data, state.fastResults)
        }
      }
      return state;
    default:
      return state;
  }
}

function applyRaceUpdate(update, fastResults) {
  return addNewRaceUpdate(
    fastResults.reduce((raceData, race) => {
      
      if (raceData.update && race.race_reference.id === raceData.update.race_reference.id) {
        if (timeStampToUnix(raceData.update.feed_received) > timeStampToUnix(race.feed_received)) {
          return { races:[...raceData.races, raceData.update], update: null };
        } else {
          return { races:[...raceData.races, race], update: null };
        }
      }
      return { races:[...raceData.races, race], update: raceData.update};
    }, { races:[], update }),
    FR_RACE_LIMIT
  )
}

function addNewRaceUpdate(raceUpdates, maxItems = 10) {
  const { update = null, races = [] } = raceUpdates;
  if (!update) {
    return races;
  }

  const updatedRaces = [update, ...races];
  if (updatedRaces.length > maxItems) {
    return updatedRaces.slice(0, (maxItems - 1))
  }
  return updatedRaces
}

export function createParams(location = {}) {
  const allResults = location.pathname && location.pathname.endsWith('all')
  return allResults ? {} : {countryGroups : 'UK,IRE'};
}

export function isLoading(globalState) {
  return globalState.horseRacing
      && globalState.horseRacing.fastResults
      && globalState.horseRacing.fastResults.loading;
}

export function load(params) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.horseRacing.loadFastResult, {params})
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/fastResults.js